import { RefObject, createContext, useContext } from 'react';

type MainContainerRefType = RefObject<HTMLDivElement | null>;

export const MainContainerRefContext = createContext<MainContainerRefType | undefined>(undefined);
export const useMainContainerRef = () => useContext(MainContainerRefContext);
